/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentClassificationUpdateRequest
 */
export interface TournamentClassificationUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof TournamentClassificationUpdateRequest
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentClassificationUpdateRequest
     */
    totalPositions?: number;
}

/**
 * Check if a given object implements the TournamentClassificationUpdateRequest interface.
 */
export function instanceOfTournamentClassificationUpdateRequest(value: object): value is TournamentClassificationUpdateRequest {
    return true;
}

export function TournamentClassificationUpdateRequestFromJSON(json: any): TournamentClassificationUpdateRequest {
    return TournamentClassificationUpdateRequestFromJSONTyped(json, false);
}

export function TournamentClassificationUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentClassificationUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'totalPositions': json['totalPositions'] == null ? undefined : json['totalPositions'],
    };
}

export function TournamentClassificationUpdateRequestToJSON(json: any): TournamentClassificationUpdateRequest {
    return TournamentClassificationUpdateRequestToJSONTyped(json, false);
}

export function TournamentClassificationUpdateRequestToJSONTyped(value?: TournamentClassificationUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'totalPositions': value['totalPositions'],
    };
}

